<div *ngIf="!isConsented" class="cookieBanner">
  <div>
    <div style="float: left;">This website uses cookies. By navigating around this site, you consent to cookies being stored on your machine.</div>
    <a class="button cookieButton" (click)="consent(true, $event)">Accept</a>
    <a class="button cookieButton" routerLink="/About/Cookies">Our Cookies</a>
  </div>
</div>